// eslint-disable-next-line @typescript-eslint/triple-slash-reference -- ambient global.d.ts has no runtime JS counterpart to import
/// <reference path="./global.d.ts" />
import { logData } from "@jetblue/dotcom-fe-logger";

const USER_ACTIVE_CONSENT_STORAGE_KEY = "userActiveConsent";

export const updateDynamicYieldConsent = (value: boolean) => {
  void logData({ message: "DY consent updated", newValue: value });
  if (globalThis.DY) {
    globalThis.DY.userActiveConsent = {
      accepted: value,
    };

    globalThis.DYO?.ActiveConsent.updateConsentAcceptedStatus(value);
  }
  try {
    localStorage.setItem(
      USER_ACTIVE_CONSENT_STORAGE_KEY,
      JSON.stringify(value),
    );
  } catch {
    console.error("We couldn't save the value of the consent,", value);
  }
};
